import { NameDto } from 'api/Common/Types'

export interface DividendPaymentDataDto {
  amount: number
  broker: NameDto
  comment: string
  companyName?: string
  currency: NameDto<string>
  eventDate: string
  eventSubType: NameDto
  eventType: NameDto
  exchangeSymbol?: string
  id: string
  instrument: NameDto
}

export interface CreateDividendPaymentDataDto {
  eventSubTypeId: number
  eventTypeId: number
  brokerSymbol: string
  eventDate: string
  amount: number
  currencyId: string
  comment: string
}

export interface UpdateDividendPaymentDataDto {
  id: string
  eventSubTypeId: number
  eventTypeId: number
  brokerSymbol: string
  eventDate: string
  amount: number
  currencyId: string
  comment: string
}

export interface DividendPaymentDataLineDto {
  lineNumber: number
  status?: string
  dividendPaymentData: DividendPaymentDataDto
}

export interface UploadDividendPaymentDataDto {
  totalItemsCount: number
  createdItemsCount: number
  updatedItemsCount: number
  ignoredItemsCount: number
  items: DividendPaymentDataLineDto[]
}

export enum DividendPaymentKey {
  brokerSymbol = 'exchangeSymbol',
  companyName = 'companyName',
  amount = 'amount',
  declarationDate = 'declarationDate',
  exDividendDate = 'exDividendDate',
  paymentDate = 'paymentDate',
  currency = 'currency.name',
  dividendType = 'dividendType.name',
}

export enum DividendPaymentFilterKey {
  brokerSymbol = 'Symbol',
  companyName = 'CompanyName',
  amount = 'Amount',
  declarationDate = 'DeclarationDate',
  exDividendDate = 'ExDate',
  paymentDate = 'PaymentDate',
  currency = 'Currency.Name',
  dividendType = 'DividendType.Name',
}

export enum DividendPreviewUploadKey {
  brokerSymbol = 'dividendPaymentData.exchangeSymbol',
  eventType = 'dividendPaymentData.eventType.name',
  eventSubType = 'dividendPaymentData.eventSubType.name',
  eventDate = 'dividendPaymentData.eventDate',
  amount = 'dividendPaymentData.amount',

  currency = 'dividendPaymentData.currency.id',
  comment = 'dividendPaymentData.comment',
}
